export class PaymentSplit {
  accountNo: number;
  useVat: boolean;
  amount: string;

  constructor(json: any) {
    this.accountNo = json.accountNo;
    this.useVat = json.useVat;
    this.amount = json.amount;
  }
}
